import React from 'react';
import { Spinner } from 'react-bootstrap';
import { Form, FormGroup, ValidationMessage } from '~/components/Form';
import { ServicesContext } from '~/services';

interface EnterVerificationProps {
    edit: () => void;
    userPhone: UserPhoneType;
}
function EnterVerification({ edit, userPhone }: EnterVerificationProps) {
    const servicesContext = React.useContext(ServicesContext);
    const [verification, setVerification] = React.useState('');
    const [validation, setValidation] = React.useState(false);
    const [saving, setSaving] = React.useState(false);

    async function handleSubmit() {
        try {
            setSaving(true);
            await servicesContext.user.verifyPhone(verification, userPhone.id);
            servicesContext.alert.set(
                'Mobile number has been verified for 2-step verification',
                'success'
            );
            edit();
        } catch (e) {
            setValidation(true);
        } finally {
            setSaving(false);
        }
    }

    return (
        <Form onSubmit={handleSubmit} values={{ verification }} autoComplete="off">
            <FormGroup htmlFor="verification" className="mb-3 row">
                <div className="offset-3 col-9">
                    <input
                        className="form-control"
                        id="verification"
                        maxLength={6}
                        onChange={(e) => setVerification(e.target.value)}
                        placeholder="Enter verification code"
                        type="text"
                        value={verification}
                    />
                    <div className="text-center mt-2">
                        A verification code has been sent to your device. Please enter the code here
                        when you have received it.
                    </div>
                </div>
                <ValidationMessage
                    className="col-12 mt-2 text-center"
                    type="external"
                    rule={validation}
                >
                    The temporary identification code you entered is incorrect. Please enter it
                    again or click Cancel to start over.
                </ValidationMessage>
            </FormGroup>
            <div className="row">
                <div className="col-12 text-end">
                    <button className="btn btn-secondary me-2" onClick={edit} type="button">
                        Cancel
                    </button>
                    <button
                        className="btn btn-primary"
                        disabled={verification.trim().length !== 6 || saving}
                        type="submit"
                    >
                        {saving && (
                            <Spinner
                                animation="border"
                                className="me-1"
                                role="status"
                                size="sm"
                                variant="light"
                            />
                        )}
                        Verify Phone
                    </button>
                </div>
            </div>
        </Form>
    );
}

export { EnterVerification };
